import * as yup from "yup";

export const COLOR_PALETTE = [
  { hex: "#EF4444", name: "Rojo" },
  { hex: "#F97316", name: "Naranja" },
  { hex: "#EAB308", name: "Amarillo" },
  { hex: "#22C55E", name: "Verde" },
  { hex: "#14B8A6", name: "Turquesa" },
  { hex: "#3B82F6", name: "Azul" },
  { hex: "#6366F1", name: "Índigo" },
  { hex: "#A855F7", name: "Morado" },
  { hex: "#EC4899", name: "Rosa" },
  { hex: "#92400E", name: "Café" },
  { hex: "#6B7280", name: "Gris" },
  { hex: "#1F2937", name: "Negro" },
];

const validColors = COLOR_PALETTE.map((c) => c.hex);

export const tagFormSchema = yup.object({
  name: yup
    .string()
    .required("El nombre es requerido")
    .max(50, "Máximo 50 caracteres")
    .trim(),
  color: yup
    .string()
    .required("El color es requerido")
    .oneOf(validColors, "Color inválido"),
});

export type TagFormSchema = yup.InferType<typeof tagFormSchema>;
